import styled from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-300);
`

export const Inner = styled.div`
  display: flex;
  gap: var(--space-400);
  flex-direction: column-reverse;
  align-items: flex-start;

  ${mediaQueries.tablet} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`

export const Tools = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-400);
  max-width: 100%;

  & > * {
    flex: 1;
    max-width: 100%;
  }

  ${mediaQueries.tablet} {
    flex: initial;
  }
`

export const Actions = styled.div`
  display: none;
  align-items: center;
  gap: var(--space-400);
  align-self: flex-start;

  ${mediaQueries.tablet} {
    display: flex;
  }
`
